import { Divider, Grid } from '@material-ui/core';
import { modalsToggle } from 'actions';
import { SendOfferModal } from 'components/Offers';
import { useNoSelectorVehicleOfferAuctionById } from 'hooks';
import { ActionDivider } from 'pages/Admin/ViewVehicle/components/UI';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Vehicle } from 'types/vehicle';

const StyledSpan = styled.span`
  color: #d50808;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
`;

const StyledDivider = styled(Divider)`
  && {
    margin: 24px 0;
  }
`;

type Props = {
  vehicle: Vehicle;
};

export const StopNegotiation = ({ vehicle }: Props) => {
  const dispatch = useDispatch();

  return (
    <Grid item xs={12}>
      <StyledSpan onClick={() => dispatch(modalsToggle(`stop-negotiation-${vehicle.id}`))}>
        Stop Countering between Seller and Top Buyer
      </StyledSpan>
      <SendOfferModal
        maxAmount={vehicle.reserve_price}
        form={`stop-negotiation-${vehicle.id}`}
        vehicle={vehicle}
        type="stop-negotiation"
      />
      <ActionDivider />
    </Grid>
  );
};
